import { IconWrapper } from '../runtime';
export default IconWrapper('logo-wps365-logo', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0.616118 1.4716L7.79407 3.39807C8.00774 3.4555 8.15625 3.6492 8.15625 3.87045V15.8521L0 22.5469V1.94398C0 1.67383 0.218999 1.45483 0.489147 1.45483C0.532023 1.45483 0.574712 1.46047 0.616118 1.4716Z",
      "fill": "#E64950"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.0832 2.90625C14.5331 2.90625 14.8978 3.27199 14.8978 3.72314C14.8978 3.87726 14.8552 4.02141 14.7813 4.14442L19.1944 11.9248L0 22.5469L13.3994 3.27911C13.5446 3.0547 13.7966 2.90625 14.0832 2.90625Z",
      "fill": "#B12535"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M23.5108 2.90625C23.7809 2.90625 23.9999 3.12525 23.9999 3.3954C23.9999 3.48076 23.9776 3.56464 23.9351 3.6387L19.3424 11.6833C19.256 11.834 19.256 12.0192 19.3424 12.1699L23.9351 20.1738C24.0695 20.4082 23.9884 20.7071 23.7541 20.8414C23.68 20.8839 23.5961 20.9062 23.5108 20.9062H15.9823C15.6317 20.9062 15.3079 20.7187 15.1336 20.4146L10.5424 12.4132C10.3696 12.1118 10.3696 11.7413 10.5424 11.44L14.7489 4.0684L14.747 4.06671C14.8116 3.95339 14.8485 3.82216 14.8485 3.6823C14.8485 3.25942 14.5112 2.91554 14.0917 2.90643L23.5108 2.90625Z",
      "fill": "#E64950"
    }
  })]);
});